module.exports = __webpack_public_path__ + "static/media/19.4186f7a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/19.png
// module id = 1457
// module chunks = 0